import api from "./api";
import publicApi from "./publicApi";


export const downloadInvoicePDF = async (unique_string) => {
  try {
    const response = await publicApi.get(
      `invoice/download_invoice/${unique_string}`,
      {
        responseType: "blob",   
      }
    );

    // Extract filename from Content-Disposition header
    let filename = "invoice.pdf"; // Default fallback
    const contentDisposition = response.headers['content-disposition'];
    
    if (contentDisposition) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(contentDisposition);
      
      if (matches != null && matches[1]) {
        // Remove quotes if present
        filename = matches[1].replace(/['"]/g, '');
      }
    }

    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
    
    const link = document.createElement("a");
    link.href = fileURL;
    link.download = filename; // Use extracted filename
    document.body.appendChild(link);

    link.click();

    link.remove();
    window.URL.revokeObjectURL(fileURL);
  } catch (error) {
    console.error("Error downloading invoice PDF:", error);
  }
};





export const downloadDineInInvoicePDF = async (order_id) => {
  try {
    const response = await publicApi.get(
      `table_order/download_dinein_invoice/${order_id}`,
      {
        responseType: "blob",   
      }
    );

    // Extract filename from Content-Disposition header
    let filename = "invoice.pdf"; // Default fallback
    const contentDisposition = response.headers['content-disposition'];
    
    if (contentDisposition) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(contentDisposition);
      
      if (matches != null && matches[1]) {
        // Remove quotes if present
        filename = matches[1].replace(/['"]/g, '');
      }
    }

    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
    
    const link = document.createElement("a");
    link.href = fileURL;
    link.download = filename; // Use extracted filename
    document.body.appendChild(link);

    link.click();

    link.remove();
    window.URL.revokeObjectURL(fileURL);
  } catch (error) {
    console.error("Error downloading invoice PDF:", error);
  }
};